import React from 'react';
import Typography from '@smart-tv/components/typography';
import formatDuration from '@smart-tv/utils/formatter/format-duration';
import styles from './player-product-sheet-info.module.scss';

interface ProgramMetadataProps {
  channelName?: string;
  releaseYear?: string;
  durationInSeconds?: number;
}

const ProgramMetadata = ({ channelName, releaseYear, durationInSeconds }: ProgramMetadataProps) => {
  const durationFormatted = durationInSeconds && formatDuration(durationInSeconds);
  const parts = [channelName, releaseYear, durationFormatted].filter(Boolean);
  const displayText = parts.join(' | ');

  return (
    <Typography
      variant="caption2"
      component="p"
      className={styles['player-product-sheet-info__meta']}
    >
      {displayText}
    </Typography>
  );
};

export default ProgramMetadata;
